import script from "./Siding15Package.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding15Package.vue?vue&type=script&setup=true&lang=js"

import "./Siding15Package.vue?vue&type=style&index=0&id=065d0890&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065d0890"]])

export default __exports__